export class ConfiguracionEmisionFilter {
   public emisorId: string;
   public tipoDteId: string;
   public activo: number;
}
